import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { CRUDFunction } from "../../../../reduxCURD/container";
import MaintenanceTable from "./MaintenanceTable";
import { languageService } from "../../../../Language/language.service";
import { deriveCRUDNames } from "../../crudHelpers";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { DashboardPageStyle } from "../../../Dashboard/styles/DashboardPageStyle";
import { commonStylesDashboard } from "../../../Dashboard/styles/commonStylesDashboard";
import { CommonWidgetMethods } from "../Common";
import { SelectField } from "../../../Reports/Timps/reportfilter";
import PropagateLoader from "react-spinners/PropagateLoader";
class MaintenanceListWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maintenanceDataToShow: [],
      selectedSourceType: "all",
      spinnerLoading: false,
      listPage: 0,
      menuOptions: [
        { val: "all", text: "All" },
        { val: "app-issue", text: "Issue" },
        { val: "manual-app-workorder", text: languageService("App") },
        { val: "web-issue", text: languageService("Web") },
      ],
    };
  }
  fetchCall(settings, dateRange, filterLocations) {
    let sett = settings.map((s) => {
      return { ...s, lineIds: filterLocations };
    });
    // const url = `summary?settings=${JSON.stringify(sett)}&dateRange=${JSON.stringify(dateRange)}`;

    // this.props.getMaintenanceLists(url);

    this.props.createMaintenanceList(
      {
        settings: sett,
        dateRange: dateRange,
      },
      "WidgetSettings",
      "/summary",
    );
  }
  componentDidMount() {
    const { settings } = this.props.settings;
    const { dateRange, filterLocations, maintenanceLists } = this.props;
    this.fetchCall(settings, dateRange, filterLocations);
  }

  componentDidUpdate(prevProps) {
    const { settings } = this.props.settings;
    const { dateRange, actionType, maintenanceLists, filterLocations } = this.props;

    if (actionType === "MAINTENANCELIST_CREATE_REQUEST" && actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: true });
    }

    const dateChanged = dateRange.month !== prevProps.dateRange.month || dateRange.year !== prevProps.dateRange.year;

    if (dateChanged || filterLocations !== prevProps.filterLocations) {
      this.fetchCall(settings, dateRange, filterLocations);
    }

    if (actionType === "MAINTENANCELIST_CREATE_SUCCESS" && actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: false, maintenanceDataToShow: maintenanceLists });
    }

    if (actionType === "MAINTENANCELIST_CREATE_FAILURE" && actionType !== prevProps.actionType) {
      console.error("Failed to fetch maintenance data.");
      this.setState({ spinnerLoading: false });
    }
  }

  handlePageStateSave = (page) => {
    this.setState({ listPage: page });
  };

  handleSourceChange = (e) => {
    this.setState({ selectedSourceType: e.target.value });
  };
  getCombinedData() {
    const { maintenanceDataToShow } = this.state;
    let maintenanceList = maintenanceDataToShow ? maintenanceDataToShow.maintenanceList : {};
    let list = [];

    if (maintenanceList && maintenanceList.lines) {
      Object.entries(maintenanceList.lines).forEach(([id, val]) => {
        list.push(...val.list);
      });
    }

    return list;
  }
  render() {
    const { maintenanceDataToShow, selectedSourceType, menuOptions, spinnerLoading } = this.state;
    let filteredData = this.getCombinedData();

    if (selectedSourceType !== "all") {
      filteredData = filteredData.filter((item) => item.sourceType === selectedSourceType);
    }
    let sorted = filteredData.sort((a, b) => {
      const numA = parseInt(a.mrNumber.split("#")[1], 10);
      const numB = parseInt(b.mrNumber.split("#")[1], 10);
      return numB - numA;
    });

    if (spinnerLoading || !maintenanceDataToShow) {
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 150 }}>
          <PropagateLoader
            color={themeService({ default: "rgb(55, 139, 119)", retro: "var(--first)", electric: "rgba(64, 118, 179,.5)" })}
            sizeUnit={"px"}
            size={10}
          />
        </div>
      );
    }
    return (
      <div md="12" style={{ padding: "20px", margin: 0, backgroundColor: "white" }}>
        <Row className="align-items-center">
          <Col md="6">
            <Row style={themeService(DashboardPageStyle.headingRow)}>{languageService("Work Order")}</Row>
          </Col>
          <Col md="6" className="text-right">
            <SelectField
              inputFieldProps={{ name: "source", label: "Source" }}
              options={menuOptions}
              changeHandler={this.handleSourceChange}
              value={selectedSourceType}
            />
          </Col>
        </Row>
        <Row style={themeService(DashboardPageStyle.tablesContainerRow)}>
          <Col
            style={{
              ...themeService(commonStylesDashboard.innerContainerCol),
              padding: 0,
              margin: 0,
            }}
          >
            <MaintenanceTable maintenanceList={sorted} pageSize={8} pagination={true} />
          </Col>
        </Row>
      </div>
    );
  }
}

const actionOptions = {
  create: true,
  update: false,
  read: true,
  delete: false,
};

const MaintenanceListWidgetContainer = CRUDFunction(MaintenanceListWidget, "maintenanceList", actionOptions, null, [], "dashboard");

export default MaintenanceListWidgetContainer;



// WEBPACK FOOTER //
// ./src/components/NewDashboard/widgets/MaintenanceListWidget/MaintenanceListWidget.jsx